// exports the environment variables as object
const baseKey = 'VUE_APP_';
const config = {};
if (process.env) {
  Object.keys(process.env).forEach((key) => {
    config[key.replace(baseKey, '')] = process.env[key];
  });
}
export default config;
